module.exports = __webpack_public_path__ + "img/new.2b4decfd.svg";